module.exports = __webpack_public_path__ + "img/DE02695.54174fe5.png";